import set from 'lodash/set';
import moment from 'moment-timezone';

import SubjectToTaxTypes from '../../../constants/SubjectToTaxTypes';

function cleanState() {
  return {
    voucherType: 'I',
    voucherConsecutive: '',
    voucherCurrency: 'MXN',
    voucherExchangeRate: null,
    voucherSeries: '',
    voucherPaymentType: '01',
    voucherPaymentMethod: 'PUE',
    voucherDate: moment().tz('America/Mexico_City').format(),
    voucherTotal: '',
    voucherSubTotal: '',
    receiverOptionsRfcList: [],
    receiverCfdiUsage: 'G03',
    receiverName: '',
    receiverRfc: '',
    receiverFiscalResidence: '',
    receiverNumRegIdTrib: '',
    receiverZipCode: '',
    receiverTaxRegime: '',
    totalTaxesTransferred: '',
    voucherComments: '',
    exportation: '01',
    operation: {
      stamped: false,
      owner: 0,
      customer: 0,
      ownerCompany: 0,
      customerCompany: 0,
      status: 0,
    },
    cfdisRelated: [],
    amounts: [],
    concepts: [
      {
        productServiceKey: '',
        identificationNumber: '',
        quantity: null,
        unitKey: '',
        description: '',
        unit: null,
        amount: null,
        id: 1,
        subjectToTax: '02',
        taxTransfers: [
          {
            base: null,
            tax: '002',
            factorType: 'Tasa',
            fee: '0.160000',
            amount: null,
            type: 'transfer',
          },
        ],
        retainedTaxes: [],
        localTaxTransfers: [],
        localTaxWithHolds: [],
      },
    ],
    complement:
    {
      payments: [
        {
          id: 1,
          wayPay: '01',
          currency: 'MXN',
          exchangeRate: '1',
          operationNumber: null,
          issuingRfc: null,
          bankName: null,
          issuingAccount: null,
          receiverRfc: null,
          receiverAccount: null,
          amount: '',
          paymentDate: moment().unix(),
          documentsRelated: [
            {
              id: 1,
              documentId: '',
              documentSeries: '',
              documentConsecutive: '',
              documentPreviousBalance: '',
              documentCurrency: 'MXN',
              documentExchangeRate: 1,
              documentPartialityNumber: '',
              documentAmountPaid: '',
              documentOutstandingBalance: '',
              documentInvoiceExchangeRate: null,
              documentConversionAmountPaid: '',
              documentTotal: '',
              documentTaxTransfers: [],
              documentTaxWithholdings: [],
              objectImpDr: '',
            },
          ],
          taxes: null,
        },
      ],
    },
  };
}

export default {
  setValue(state, { accessor, value }) {
    set(state, accessor, value);
  },

  setValues(state, payload) {
    Object.keys(payload).forEach((key) => {
      set(state, key, payload[key]);
    });
  },

  setInitialState(state) {
    const init = cleanState();
    Object.keys(init).forEach((key) => {
      set(state, key, init[key]);
    });
  },

  addDocument(state, { index, document }) {
    const currentPayment = state.complement.payments.find(
      ({ id }) => id === (index),
    );
    set(document, 'id', currentPayment.documentsRelated.length + 1);
    currentPayment.documentsRelated.push(document);
  },

  updateDocument(state, payload) {
    const {
      accessor,
      value,
      payment,
      index,
    } = payload;

    set(state.complement.payments[payment - 1].documentsRelated[index - 1], accessor, value);
  },

  deleteDocument(state, { paymentIndex, documentIndex }) {
    const index = state.complement.payments[paymentIndex - 1].documentsRelated.findIndex(
      ({ id }) => id === documentIndex,
    );
    state.complement.payments[paymentIndex - 1].documentsRelated.splice(index, 1);
  },

  initialDocuments(state, { template }) {
    const accessor = 'documentsRelated';
    const value = [];
    set(state.complement.payments[0], accessor, value);
    set(document, 'id', 1);
    state.complement.payments[0].documentsRelated.push(template);
  },

  addPayment(state, payment) {
    set(payment, 'id', state.complement.payments.length + 1);
    state.complement.payments.push(payment);
  },

  updatePayment(state, { accessor, value }) {
    set(state.complement.payments[0], accessor, value);
  },

  deletePayment(state, paymentIndex) {
    const index = state.complement.payments.findIndex(
      ({ id }) => id === paymentIndex,
    );
    state.complement.payments.splice(index, 1);
  },

  setPaymentFromDoc(state, { paymentIndex, accessor, value }) {
    set(state.complement.payments[paymentIndex - 1], accessor, value);
  },

  addConcept(state, concept) {
    set(concept, 'id', state.concepts.length + 1);
    state.concepts.unshift(concept);
  },

  addConcepts(state, concepts) {
    concepts.forEach((concept) => {
      if (!concept.subjectToTax) {
        const hasTaxes = !!(concept.taxTransfers || concept.retainedTaxes);

        concept.subjectToTax = hasTaxes ? SubjectToTaxTypes.EnableTaxObject
          : SubjectToTaxTypes.NotTaxObject;
      }

      set(concept, 'id', state.concepts.length + 1);
      state.concepts.push(concept);
    });
  },

  updateConcept(state, { accessor, value }) {
    set(state, accessor, value);
  },

  updateConceptValues(state, { index, values }) {
    Object.keys(values).forEach((key) => {
      set(state, `concepts.${index}.${key}`, values[key]);
    });
  },

  deleteConcept(state, conceptIndex) {
    const index = state.concepts.findIndex(({ id }) => id === conceptIndex);
    state.concepts.splice(index, 1);
  },

  addConceptTax(state, { index: conceptIndex, tax }) {
    const concept = state.concepts.find(({ id }) => id === conceptIndex);

    if (!concept) return;

    if (tax.type === 'retained') {
      if (Array.isArray(concept.retainedTaxes)) {
        concept.retainedTaxes.push(tax);
      } else {
        concept.retainedTaxes = [tax];
      }
    } else if (tax.type === 'transfer') {
      if (Array.isArray(concept.taxTransfers)) {
        concept.taxTransfers.push(tax);
      } else {
        concept.taxTransfers = [tax];
      }
    } else if (tax.type === 'localTransfer') {
      if (Array.isArray(concept.localTaxTransfers)) {
        concept.localTaxTransfers.push(tax);
      } else {
        concept.localTaxTransfers = [tax];
      }
    } else if (tax.type === 'localWithHold') {
      if (Array.isArray(concept.localTaxWithHolds)) {
        concept.localTaxWithHolds.push(tax);
      } else {
        concept.localTaxWithHolds = [tax];
      }
    }
  },

  deleteConceptTax(state, payload) {
    const {
      index: conceptIndex,
      tax,
      type,
      fee,
    } = payload;

    const concept = state.concepts.find(({ id }) => id === conceptIndex);

    const filterFuction = t => !(
      t.tax === tax && (parseFloat(t.fee) === parseFloat(fee) || t.fee === fee)
    );

    if (type === 'retained') {
      concept.retainedTaxes = concept.retainedTaxes.filter(filterFuction);
    } else if (type === 'localTransfer') {
      concept.localTaxTransfers = concept.localTaxTransfers.filter(filterFuction);
    } else if (type === 'localWithHold') {
      concept.localTaxWithHolds = concept.localTaxWithHolds.filter(filterFuction);
    } else {
      concept.taxTransfers = concept.taxTransfers.filter(filterFuction);
    }
  },

  addCfdiRelated(state, { type, uuid }) {
    const related = state.cfdisRelated.find(cfdis => cfdis.relationType === type);

    if (!related) {
      state.cfdisRelated.push({ relationType: type, uuids: [uuid] });
    } else if (!related.uuids.includes(uuid)) {
      related.uuids.push(uuid);
    }
  },

  deleteUuidsRelated(state, { uuid }) {
    state.cfdisRelated.forEach((cfdi, index) => {
      const uuidRelatedIndex = cfdi.uuids.indexOf(uuid);

      if (uuidRelatedIndex !== -1) {
        state.cfdisRelated[index].uuids.splice(uuidRelatedIndex, 1);

        if (!state.cfdisRelated[index].uuids.length > 0) {
          state.cfdisRelated.splice(index, 1);
        }
      }
    });
  },

  deleteCfdiRelated(state, { type }) {
    const index = state.cfdisRelated.findIndex(({ relationType }) => relationType === type);

    if (index !== -1) {
      state.cfdisRelated.splice(index, 1);
    }
  },

  addAmount(state, { uuid, amount }) {
    const { amounts } = state;
    amounts.push({ uuid, amount });
  },
};
